/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import { graphql, useStaticQuery } from "gatsby";
import { GatsbySeo, MetaProps, OpenGraph } from "gatsby-plugin-next-seo";
import React from "react";

interface SEOProps {
  title: string;
  description: string;
  meta?: MetaProps[];
  lang?: string;
  titleIncludePs?: boolean;
  nofollow?: boolean;
  noindex?: boolean;
  ogImageSrc?: string;
  canonical?: string;
}

const SEO: React.FunctionComponent<SEOProps> = ({
  title,
  description,
  lang = "en",
  meta = [],
  titleIncludePs = true,
  nofollow = false,
  noindex = false,
  ogImageSrc = "",
  canonical,
}) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            author
          }
        }
      }
    `
  );

  const fullTitle = titleIncludePs
    ? `${title} | ${site.siteMetadata.title}`
    : title;

  const og: OpenGraph = {
    title: fullTitle,
    description,
    type: "website",
  };

  if (ogImageSrc) {
    og.images = [
      {
        url: ogImageSrc,
      },
    ];
  }

  return (
    <GatsbySeo
      title={fullTitle}
      description={description}
      language={lang}
      nofollow={nofollow}
      noindex={noindex}
      openGraph={og}
      metaTags={meta}
      canonical={canonical}
    />
  );
};

export default SEO;
